<template>
  <div class="button_content">
    <el-button class="alone_button">{{text}}</el-button>
  </div>
</template>

<script>
  export default {
    name: "alone-button",
    props: {
      text: {
        type: String,
        default: '确定'
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .button_content
    width: 100%
    margin: 20px 0
    text-align: center
    .alone_button
      background: #00abad
      width: 220px
      text-align: center
      color: #fff !important
      margin-bottom: 20px
</style>



// WEBPACK FOOTER //
// aloneButton.vue?11576016